"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.MealVkusvillDbmlFilled = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _SvgIcon = require("../SvgIcon");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var MealVkusvillDbmlFilled = function MealVkusvillDbmlFilled(props) {
  return /*#__PURE__*/React.createElement(_SvgIcon.SvgIcon, (0, _extends2.default)({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.223 10.407c.13.124.288.212.462.255v.063a1.146 1.146 0 01.843 1.448 1.162 1.162 0 01-1.416.764l-.51-.127a.319.319 0 00-.238 0l-2.816 2.689c.29.916.333 1.893.127 2.832a8.544 8.544 0 01-2.354 4.455 5.775 5.775 0 01-3.946 1.75 4.565 4.565 0 01-4.598-4.773 5.855 5.855 0 011.909-3.899 8.497 8.497 0 014.439-2.18c.363-.06.73-.092 1.098-.095a4.77 4.77 0 011.734.303l2.912-2.753a.255.255 0 000-.27 3.171 3.171 0 01-.144-.525 1.145 1.145 0 01.637-1.241 1.162 1.162 0 011.623.86.875.875 0 00.238.444zm-9.848 14.844a6.507 6.507 0 004.391-1.94 8.878 8.878 0 001.861-2.737 8.354 8.354 0 011.353 4.296c0 4.836-8.098 5.695-17.374 5.695h-.43c-8.243.002-13.299.003-13.174-6.268.128-6.38 5.569-12.124 14.05-11.901 2.684.054 5.33.65 7.78 1.75a8.627 8.627 0 00-1.671 1.21 6.54 6.54 0 00-2.02 4.374 5.201 5.201 0 005.234 5.521z",
    fill: "#97BA1E"
  }));
};

exports.MealVkusvillDbmlFilled = MealVkusvillDbmlFilled;
var _default = MealVkusvillDbmlFilled;
exports.default = _default;